/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalLogs200LogsItemAction =
    (typeof GetApiDoctorsPortalLogs200LogsItemAction)[keyof typeof GetApiDoctorsPortalLogs200LogsItemAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalLogs200LogsItemAction = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED',
    PINNED: 'PINNED',
    UNPINNED: 'UNPINNED',
    PRIORITY_CHANGED: 'PRIORITY_CHANGED',
    INVITED: 'INVITED',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    UNLINKED: 'UNLINKED',
} as const;
